import { Scroll } from '@dreryk/react-components';

import {
   ExtendedDosageForm,
   ExtendedDosageFormRenderProps,
} from '../../../prescriptions/prescription/extendedDosage/form/ExtendedDosageForm';
import { TemplatesFormProps } from '../../../../../shared/types';
import { DosageTemplateListItem } from '../DosageTemplates.types';
import { createDosageTemplateFormBeanInitializer } from '../DosageTemplates.utils';

import { useDosageTemplateFormSynchronization } from './DosageTemplateForm.hooks';

export type DosageTemplateFormChildrenRenderProps = Pick<
   ExtendedDosageFormRenderProps,
   'handleSubmit' | 'formState' | 'saveBlocked'
>;

type DosageTemplateFormProps = TemplatesFormProps<DosageTemplateListItem, DosageTemplateFormChildrenRenderProps>;

type DosageTemplateFormContentProps = Omit<DosageTemplateFormProps, 'template'> & {
   readonly formProps: ExtendedDosageFormRenderProps;
};

const DosageTemplateFormContent = (props: DosageTemplateFormContentProps): JSX.Element => {
   const { formProps } = props;

   useDosageTemplateFormSynchronization({
      formState: formProps.formState,
      watch: formProps.watch,
      control: formProps.control,
      onDirty: props.onDirty,
      onPristine: props.onPristine,
      onTemplateNameChange: props.onTemplateNameChange,
      templatesApiRef: props.templatesApiRef,
   });

   return props.children({
      handleSubmit: formProps.handleSubmit,
      formState: formProps.formState,
      saveBlocked: formProps.saveBlocked,
   });
};

export const DosageTemplateForm = (props: DosageTemplateFormProps): JSX.Element => {
   return (
      <Scroll testId={'dosageTemplate'}>
         <ExtendedDosageForm
            key={props.template?.id}
            initializer={createDosageTemplateFormBeanInitializer(props.template)}
            portionUnit={null}
            context={{ mode: 'TEMPLATE' }}
         >
            {(formProps) => (
               <DosageTemplateFormContent
                  formProps={formProps}
                  onDirty={props.onDirty}
                  onPristine={props.onPristine}
                  onTemplateNameChange={props.onTemplateNameChange}
                  templatesApiRef={props.templatesApiRef}
               >
                  {props.children}
               </DosageTemplateFormContent>
            )}
         </ExtendedDosageForm>
      </Scroll>
   );
};
